/**
 * Created by caoshi on 2017/6/22.
 */
import config from './config/index'

//配置全局 URL 开发环境 生产环境
let appConfig = {
  API: {
    DOMAIN_NAME: config.DOMAIN_NAME,
    WS_BASE_URL: config.WS_BASE_URL,
    BASE_URL: config.BASE_URL_V3,
    LOGIN_URL: config.LOGIN_URL,
    REDIRECT_URL: config.REDIRECT_URL,
    BACKSTAGE_URL: config.BACKSTAGE_URL,

    RECEPTION_URL: config.RECEPTION_URL,

    BASE_URL_V3: config.BASE_URL_V3,
    UPLOAD_URL: config.UPLOAD_URL,
  },

  objectStore: {
    BUCKET: config.BUCKET,
    REGION: config.REGION,
    UPLOAD_DOMAIN: config.UPLOAD_DOMAIN,
    ACCESSPATH: config.ACCESSPATH,
  },

  isDebug: config.isDebug
}
export default appConfig



// WEBPACK FOOTER //
// ./src/appConfig.js